import React, {Component} from 'react';

import {
	Sidenav, Nav, Icon
} from 'rsuite';
import { swalAction } from '../lib/functions';


class SideNav extends Component{
	constructor(props){
		super(props);

		this.changeScreen = this.changeScreen.bind(this);

		this.state = {
			title:"",
			expanded:false,
			menuOptions:[
				{title: 'home', url:'/', icon:'home', image:'ICON-home.png'},
				{title: 'employees', url:'/settings/employee', icon:'user', image:'ICON-empleado.png'},
				{title: 'locations', url:'/settings/locations', icon:'map', image:'ICON-ubicacion.png'},
				{title: 'events', url:'/settings/employee/events', icon:'calendar', image:''},
				{title: 'reports.title', url:'/reports', icon:'detail', image:'ICON-reportes.png'},
				{title: 'config_account', url:'/settings/account', icon:'cog', image:'ICON-configuracion.png'}
			],
			menu:[],
		}
	}

	componentDidMount(){
		if(this.props.expanded !== undefined){
			this.setState({expanded: this.props.expanded});
		}

		//console.log(sessionStorage.getItem('userType'))
		let user = sessionStorage.getItem('userType');
		if (user === 'client') {
			this.setState(
				{
					menu:[
						{title: 'home', url:'/', icon:'home', image:'ICON-home.png'},
						{title: 'reports.title', url:'/reports', icon:'detail', image:'ICON-reportes.png'},
					]
				}
			)
		} else if (user === 'contractor') {
			this.setState(
				{
					menu:[
						{title: 'home', url:'/', icon:'home', image:'ICON-home.png'},
						{title: 'employees', url:'/settings/employee', icon:'user', image:'ICON-empleado.png'},
					]
				}
			)
		} else {
			this.setState({menu:this.state.menuOptions});
		}

	}

	changeScreen(url){
		var verify = true;
		if(this.props.verify !== undefined){
			verify = this.props.verify();
			
			if(!verify){
				var obj = {
					title           : this.props.t('modal.alert.titles.update_employee'),
					text            : this.props.t('modal.alert.messages.update_employee'),
					icon            : 'warning',
					showConfirm     : true,
					showCancel      : true,
					textConfirm     : this.props.t('modal.alert.confirms.yes'),
					colorConfirm    : '#3085d6',
					colorCancel     : '#d33',
					textcancel      : this.props.t('modal.alert.confirms.no'),
					values          : '',
					fn              : ()=>{this.props.history.push(url);}
				}
				
				swalAction(obj);
			}else{
				this.props.history.push(url);
			}
			
		}
		if(verify){
			this.props.history.push(url);
		}
		
	}

	render(){
		const {t} = this.props;
		let canceled = JSON.parse(sessionStorage.getItem('canceled'));
		let currentPath = this.props.location ? this.props.location.pathname : '';
		// Coincidencia por segmento de ruta (no por prefijo de texto), y solo la más
		// específica gana — evita que "/settings/employee" y "/settings/employee/events"
		// queden activos al mismo tiempo.
		let activeUrl = this.state.menu.reduce((best, mi)=>{
			let matches = mi.url === '/' ? currentPath === '/' : (currentPath === mi.url || currentPath.indexOf(mi.url + '/') === 0);
			if(!matches) return best;
			return (!best || mi.url.length > best.length) ? mi.url : best;
		}, null);
		return (
			<Sidenav appearance="subtle" expanded={this.state.expanded} className="s-background-sidebar">
				<Sidenav.Body>
					<Nav>
						{this.state.menu.map((m, i)=>{
							let isActive = m.url === activeUrl;
							return (
							(m.title !== "events" || sessionStorage.getItem("suscription") !== "free")?
								<Nav.Item
									key={i}
									eventKey={i}
									disabled={canceled && m.url !== '/reports'}
									renderItem={item =>
										<a role="button" tabIndex={i} href="/#"
											className={"s-nav-item-content rs-nav-item-content"+(isActive ? " s-nav-item-active" : "")}
											onClick={(e)=>{
												e.preventDefault(); 
												return canceled && m.url !== '/reports'? 
													e.preventDefault()
												: this.changeScreen(m.url)
											}}
										>
											{m.image !== '' ? 
												<img src={"/images/icons/"+m.image}  alt="icon" 
													style={canceled && m.url !== '/reports' ? {filter: 'grayscale(0.8)'} : {}}
												/>
											:
												<Icon icon={m.icon} 
													className={
														i > 0 && i < this.state.menu.length - 1 ? "s-primary" : 
														i === this.state.menu.length - 1 ? "s-secondary" : ""
													}
													size="4x"
												/>
											}
											<span className={"rs-ripple-pond "+(m.image !== '' ? 's-submenu-image' : 's-submenu-icon')}>
												{t('menu.'+m.title)}												
											</span>
										</a>
									}
									title={t('menu.'+m.title)}
									className={
										(i > 0 && i < this.state.menu.length - 1 ? "s-background-primary" :
										i === this.state.menu.length - 1 ? "s-background-secondary" : "")
										+ (isActive ? " s-nav-item-active" : "")
									}

									style={
										i === 0 ? {borderBottom:'1px solid var(--border)'} :
										i === this.state.menu.length - 1 ? {borderTop:'1px solid var(--border)'} : {}
									}
								>
									{t('menu.'+m.title)}
								</Nav.Item>
							:null
							);
						})}
					</Nav>
				</Sidenav.Body>

			</Sidenav>
		)
	}
}

export default SideNav;